import React from 'react';
import {DataTable} from 'primereact/datatable';
import {Column} from "primereact/column";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";

const LoanableValuesView = (props) => {

    return (
        <React.Fragment>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '2%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TitlePage title="Captura Valores Prestables"/>
                        </Grid>
                        <Grid item xs={12}>

                            <div className="content-section implementation">
                                <DataTable responsive={true}
                                           header={props.headerLoanableValues}
                                           value={props.dataLoanableValues}>
                                    <Column field="folio" header="Folio"/>
                                    <Column field="tipo" header="Tipo"/>
                                    <Column field="cantidad" header="Títulos"/>
                                    <Column field="plazo" header="Plazo"/>
                                    <Column field="tasa" header="Tasa"/>
                                    <Column field="sobretasa" header="Sobretasa"/>
                                    <Column field="precioMin" header="Precio Mín"/>
                                </DataTable>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(LoanableValuesView);
